var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import { Jackpot } from "../models";
import { observable, action } from "mobx";
const WinningAnimationForAll = "ALL";
const SbPrefix = "sb_";
const ResetWinAnimationTopic = SbPrefix + "jackpot_reset_win_animations";
const WinningTopicName = SbPrefix + "jackpot_won";
const WinningAnimationShownTopicName = SbPrefix + "jackpot_won_shown";
const userLoginTopic = SbPrefix + "UserInfo.login";
const userLogoutTopic = SbPrefix + "UserInfo.logout";
export class RootStore {
    constructor(msgBus) {
        this.subscribeToUserLoginLogout = () => {
            if (this.msgBus) {
                this.msgBus.subscribe(userLoginTopic, () => {
                    this.setIsUserLoggedIn(true);
                });
                this.msgBus.subscribe(userLogoutTopic, () => {
                    this.setIsUserLoggedIn(false);
                });
            }
        };
        this.jackpots = [];
        this.jackpotWinningAnimations = [];
        this.msgBus = msgBus;
        this.currencies = {};
        this.isUserLoggedIn = false;
        this.updateJackpot = this.updateJackpot.bind(this);
        this.addOrGetJackpot = this.addOrGetJackpot.bind(this);
        this.getCurrencySymbol = this.getCurrencySymbol.bind(this);
        this.handleJackpotWin = this.handleJackpotWin.bind(this);
        this.handleJackpotWinAnimation = this.handleJackpotWinAnimation.bind(this);
        this.fetchCurrencies();
        this.subscribeUserLogout();
        this.subscribeWinningAnimation();
        this.subscribeToUserLoginLogout();
    }
    fetchCurrencies() {
        window.PageMethods && window.PageMethods.GetCurrencies((currenciesData) => {
            const currencyInfos = eval(currenciesData);
            if (!!currencyInfos && !!currencyInfos.length) {
                for (var i = 0; i < currencyInfos.length; i++) {
                    this.currencies[currencyInfos[i].CurrencyID] = currencyInfos[i].CodeHTML;
                    this.currencies[currencyInfos[i].MappedCurrencyID] = currencyInfos[i].CodeHTML;
                }
            }
        }, () => { });
    }
    getCurrencySymbol(currencyId) {
        return this.currencies[currencyId] || "";
    }
    updateJackpot(jackpotData) {
        const jackpot = this.jackpots.find(x => x.id === jackpotData.id);
        if (!jackpot) {
            return;
        }
        return jackpot.update(jackpotData);
    }
    updateJackpotTicker(jackpotId, currentValue) {
        const jackpot = this.jackpots.find(x => x.id === jackpotId);
        if (!jackpot) {
            return;
        }
        return jackpot.updateTicker(currentValue);
    }
    addOrGetJackpot(jackpotId, isAvailableCallbackFn, incrementPeriod, incrementValue) {
        let isNew = false;
        let jackpot = this.jackpots.find(x => x.id === jackpotId);
        if (!jackpot) {
            jackpot = new Jackpot(jackpotId, incrementPeriod, incrementValue);
            this.jackpots.push(jackpot);
            isNew = true;
        }
        if (isAvailableCallbackFn) {
            jackpot.addIsAvailableCallbackFn(isAvailableCallbackFn);
        }
        let jackpotRes = { jackpot, isNew };
        return jackpotRes;
    }
    emitIsAvailableChange(jackpotId, isAvailable) {
        let jackpot = this.jackpots.find(x => x.id === jackpotId);
        if (!jackpot) {
            return;
        }
        jackpot.emitIsAvailableChange(isAvailable);
    }
    markJackpotAsWon(jackpotId, lastTickerValue) {
        let jackpot = this.jackpots.find(x => x.id === jackpotId);
        jackpot && jackpot.markAsWon(lastTickerValue);
    }
    /* tslint:disable: no-non-null-assertion */
    handleJackpotWin(jackpotId) {
        let jackpot = this.jackpots.find(x => x.id === jackpotId);
        if (jackpot) {
            getJackpotData([jackpot.id]).then(jackpotData => {
                if (jackpotData && !!jackpotData.length && !!jackpotData[0]) {
                    jackpot.update(jackpotData[0]);
                    jackpot.markAsWon(jackpotData[0].currentValue);
                }
            }).catch(() => { });
        }
    }
    handleJackpotWinAnimation(jackpotData) {
        if (jackpotData.wonByMe) {
            let jackpotWinAnimation = this.jackpotWinningAnimations.find(x => x.hasId(jackpotData.jackpot.jackpotId.toString()));
            if (!jackpotWinAnimation) {
                jackpotWinAnimation = this.jackpotWinningAnimations.find(x => x.hasId(WinningAnimationForAll));
            }
            jackpotWinAnimation && jackpotWinAnimation.setWinning(jackpotData);
        }
    }
    addJackpotWinAnimationItem(jackpotWinningAnimation) {
        this.jackpotWinningAnimations.push(jackpotWinningAnimation);
    }
    subscribeWinningAnimation() {
        this.msgBus && this.msgBus.subscribe(WinningTopicName, (jackpotData) => {
            this.handleJackpotWin(jackpotData.jackpot.jackpotId);
            this.handleJackpotWinAnimation(jackpotData);
        });
    }
    subscribeUserLogout() {
        this.msgBus && this.msgBus.subscribe(ResetWinAnimationTopic, () => {
            this.jackpotWinningAnimations.forEach(x => {
                if (x.WonJackpot) {
                    x.WonJackpot.isWon = true;
                }
            });
        });
    }
    setIsUserLoggedIn(isLoggedIn) {
        this.isUserLoggedIn = isLoggedIn;
    }
    notifyWinningAnimationShown(jackpotId, userID) {
        this.msgBus.post({
            [WinningAnimationShownTopicName]: {
                jackpotId,
                userID
            }
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], RootStore.prototype, "jackpots", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], RootStore.prototype, "jackpotWinningAnimations", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], RootStore.prototype, "isUserLoggedIn", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RootStore.prototype, "setIsUserLoggedIn", null);
export const store = (() => {
    const _BUS = window["sbMsgBus"];
    let globalName = "JackpotRootStore";
    /* istanbul ignore next */
    if (window[globalName]) {
        return window[globalName];
    }
    else {
        const rootStore = new RootStore(_BUS);
        window[globalName] = rootStore;
        return rootStore;
    }
})();
//# sourceMappingURL=RootStore.js.map